// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__17VGS","logo":"Login_logo__1b2DN","link":"Login_link__2YflR","password":"Login_password__2dTpY","btnBox":"Login_btnBox__3vfO4"};